import angular, { IComponentOptions, IQService } from 'angular';
import {
    StateParams,
    StateService,
    Transition,
    TransitionService,
} from 'angular-ui-router';
import {
    FontFamilyService,
    FontListParams,
    FontListParamsStateParamsResolver,
    FontStyleService,
    IFontStyleModel,
} from '../../tn.common';
import { IPopover, PopoverService } from '../../tn.popover/service.tn.popover';
import { UserService } from '../../tn.user/service.tn.user';
import { IFavoriteList } from '../favorites-repository.service/favoritesRepository';
import template from './favorites-detail.html';
import { EmailFavoriteController } from '../email-favorite.view/emailFavorite';
import { RemoveFavoriteController } from '../remove-favorite.view/remove-favorite';

export class FavoritesDetail {
    // bindings
    filters: FontListParams = {};
    favorite?: IFavoriteList;

    // locals
    isLoggedIn = false;
    isOwner = false;
    user? = this.userService.getUser();
    styles: IFontStyleModel[] = [];

    //popovers
    buyPopover?: IPopover;
    emailFavoritePopover?: EmailFavoriteController;
    removeFavoritePopover?: RemoveFavoriteController;

    specimenText = '';

    static $inject = [
        '$q',
        '$state',
        '$stateParams',
        '$tnPopover',
        '$transitions',
        'tn.user.service',
        'FontFamilyPublicService',
        'FontStylePublicService',
    ];
    constructor(
        protected $q: IQService,
        protected $state: StateService,
        protected $stateParams: StateParams,
        protected $tnPopover: PopoverService,
        protected $transitions: TransitionService,
        protected userService: UserService,
        protected familyService: FontFamilyService,
        protected styleService: FontStyleService
    ) {
        const onTransitionSuccess = (transition: Transition) => {
            const params = transition.params();
            this.onStateParamsChanged(params);
        };
        $transitions.onSuccess(
            {
                from: 'home.account.favorites.favorite',
                to: 'home.account.favorites.favorite',
            },
            onTransitionSuccess
        );

        userService.user$.subscribe((user) => {
            this.user = user;
            this.isLoggedIn = !!user && user.id !== undefined;
            this.isOwner = user.id === this.favorite?.user;
        });
    }

    $onInit(): void {
        this.buyPopover = this.$tnPopover.popoverXS(
            angular.element('.popover-styles-add')
        );
        this.emailFavoritePopover = this.$tnPopover.popoverXS(
            angular.element('.popover-favorite-email')
        );
        this.onStateParamsChanged(this.$stateParams);
        this.isLoggedIn = !!this.user && this.user.id !== undefined;
        this.isOwner = this.user?.id === this.favorite?.user;
        // console.log('favoriteDetailController.$onInit', this);
    }

    onStateParamsChanged(params: Partial<StateParams>): void {
        const filters = FontListParamsStateParamsResolver(params);
        this.filters = filters;
        this.styles = this.favorite?.style.filter((s) => this.filter(s)) || [];
        this.$tnPopover.hide();
    }

    filter(style: IFontStyleModel): boolean {
        const categoryMatch =
            this.filters.categories == undefined ||
            this.filters.categories.length == 0 ||
            style.category.some((i) => this.filters.categories?.includes(i));

        const weightMatch =
            this.filters.weight == undefined ||
            this.filters.weight.length == 0 ||
            this.filters.weight.includes(style.weight);
        const widthMatch =
            this.filters.width == undefined ||
            this.filters.width.length == 0 ||
            this.filters.width.includes(style.width);
        const postureMatch =
            this.filters.posture == undefined ||
            this.filters.posture.length == 0 ||
            this.filters.posture.includes(style.posture);

        const match =
            categoryMatch && widthMatch && weightMatch && postureMatch;

        // console.log('favoriteDetailController.filter', {
        //     style,
        //     filters: this.filters,
        //     categoryMatch,
        //     tnWidthMatch: widthMatch,
        //     tnWeightMatch: weightMatch,
        //     postureMatch,
        // });
        return match;
    }

    showRemovePopover($event): void {
        this.removeFavoritePopover?.show($event.currentTarget);
    }

    showEmailPopover($event): void {
        if (!this.emailFavoritePopover) {
            return;
        }
        // Reset state
        this.emailFavoritePopover.email = undefined;
        this.emailFavoritePopover.show($event.currentTarget);
    }
}

export const FavoriteDetailPageComponent: IComponentOptions = {
    bindings: {
        favorite: '<',
    },
    controller: FavoritesDetail,
    controllerAs: 'vm',
    template,
};
